var exports = {
  "dL": "GuildHeader.module__headerWrapper___SUMyVl",
  "N1": "GuildHeader.module__headerContainer___SUMyVl",
  "bp": "GuildHeader.module__headerContainerActive___SUMyVl",
  "vf": "GuildHeader.module__headerContainerBanner___SUMyVl",
  "Le": "GuildHeader.module__headerContainerCollapsing___SUMyVl",
  "On": "GuildHeader.module__headerContainerNoBanner___SUMyVl",
  "nL": "GuildHeader.module__bannerClip___SUMyVl",
  "_e": "GuildHeader.module__bannerImage___SUMyVl",
  "Oo": "GuildHeader.module__bannerImageCentered___SUMyVl",
  "iI": "GuildHeader.module__headerGlass___SUMyVl",
  "nY": "GuildHeader.module__bannerGradient___SUMyVl",
  "VW": "GuildHeader.module__headerContent___SUMyVl",
  "KZ": "GuildHeader.module__headerFocusRing___SUMyVl",
  "w$": "GuildHeader.module__verifiedIcon___SUMyVl",
  "Ve": "GuildHeader.module__verifiedIconDefault___SUMyVl" + " " + "GuildHeader.module__verifiedIcon___SUMyVl",
  "J5": "GuildHeader.module__guildName___SUMyVl",
  "K8": "GuildHeader.module__guildNameDefault___SUMyVl" + " " + "GuildHeader.module__guildName___SUMyVl",
  "rr": "GuildHeader.module__guildNameWithBanner___SUMyVl" + " " + "GuildHeader.module__guildName___SUMyVl",
  "Rq": "GuildHeader.module__caretIcon___SUMyVl",
  "Ic": "GuildHeader.module__caretIconDefault___SUMyVl" + " " + "GuildHeader.module__caretIcon___SUMyVl",
  "Tu": "GuildHeader.module__caretIconWithBanner___SUMyVl" + " " + "GuildHeader.module__caretIcon___SUMyVl",
  "xu": "GuildHeader.module__caretIconOpen___SUMyVl",
  "_S": "GuildHeader.module__dotsIcon___SUMyVl",
  "D1": "GuildHeader.module__dotsIconDefault___SUMyVl" + " " + "GuildHeader.module__dotsIcon___SUMyVl",
  "GX": "GuildHeader.module__dotsIconWithBanner___SUMyVl" + " " + "GuildHeader.module__dotsIcon___SUMyVl",
};

module.exports = exports;
